import React, { useState, useEffect } from 'react';

export default function GameCompletedModal({ winner, allPlayers, onRedirectHome, goalReached, winningGoal }) {
  const [countdown, setCountdown] = useState(15);
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          setShouldRedirect(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (shouldRedirect) {
      onRedirectHome();
    }
  }, [shouldRedirect, onRedirectHome]);

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
        borderRadius: '20px',
        padding: '40px',
        maxWidth: '600px',
        width: '90%',
        maxHeight: '80vh',
        overflowY: 'auto',
        boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
        border: '3px solid #FFD700',
        textAlign: 'center'
      }}>
        {/* Winner Crown */}
        <div style={{
          fontSize: '4em',
          marginBottom: '10px'
        }}>👑</div>

        {/* Winner Announcement */}
        <h1 style={{
          color: '#FFD700',
          fontSize: '2.5em',
          marginBottom: '10px',
          textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
        }}>
          {goalReached ? '🎯 Goal Reached!' : 'Game Over!'}
        </h1>

        <h2 style={{
          color: winner.color,
          fontSize: '1.8em',
          marginBottom: '20px',
          textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
        }}>
          🎉 {winner.displayName} Wins! 🎉
        </h2>

        <div style={{
          color: '#4CAF50',
          fontSize: '1.3em',
          marginBottom: goalReached ? '10px' : '30px',
          fontWeight: 'bold'
        }}>
          Final Value: ${winner.value.toLocaleString()}
        </div>

        {goalReached && winningGoal && (
          <div style={{
            color: '#FFD700',
            fontSize: '1.1em',
            marginBottom: '30px',
            fontWeight: 'bold'
          }}>
            Reached Goal: ${winningGoal.toLocaleString()}
          </div>
        )}

        {/* Final Leaderboard */}
        <div style={{
          backgroundColor: 'rgba(255,255,255,0.05)',
          borderRadius: '10px',
          padding: '20px',
          marginBottom: '30px'
        }}>
          <h3 style={{
            color: '#FFFFFF',
            fontSize: '1.2em',
            marginBottom: '15px'
          }}>
            Final Rankings
          </h3>
          
          {allPlayers.map((player, index) => (
            <div key={player.userId} style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '8px 12px',
              marginBottom: '5px',
              backgroundColor: index === 0 ? 'rgba(255,215,0,0.2)' : 'rgba(255,255,255,0.05)',
              borderRadius: '6px',
              border: index === 0 ? '1px solid #FFD700' : '1px solid rgba(255,255,255,0.1)'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{ fontSize: '1.2em' }}>
                  {index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `${index + 1}.`}
                </span>
                <span style={{
                  color: player.color,
                  fontWeight: 'bold'
                }}>
                  {player.displayName}
                </span>
              </div>
              <span style={{
                color: '#4CAF50',
                fontWeight: 'bold'
              }}>
                ${player.value.toLocaleString()}
              </span>
            </div>
          ))}
        </div>

        {/* Countdown */}
        <div style={{
          color: '#FF6B6B',
          fontSize: '1.1em',
          marginBottom: '20px'
        }}>
          Returning to home in {countdown} seconds...
        </div>

        {/* Manual Return Button */}
        <button
          onClick={onRedirectHome}
          style={{
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '12px 24px',
            fontSize: '1.1em',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#45a049'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#4CAF50'}
        >
          Return to Home Now
        </button>
      </div>
    </div>
  );
}
